export const SET_SELECTED_POSITION = "SET_SELECTED_POSITION";
